import { Spin } from 'antd';
import type { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import type { AppRoute } from '../routes';
import { authStore, useAdminAuthState } from '../stores/auth';
import { GovernanceForbiddenPage } from '../views/governance/GovernanceForbiddenPage';

export function canAccessRoute(route: AppRoute) {
  if (!authStore.can(route.requiredRoles, route.requiredPermissions)) return false;
  if (!route.requiredAnyPermissions?.length) return true;
  return route.requiredAnyPermissions.some((permission) => authStore.canPermissions([permission]));
}

export function firstPermittedRoute(routes: readonly AppRoute[]) {
  return routes.find((route) => !route.public && !route.hideInMenu && canAccessRoute(route))?.path ?? '/login';
}

export function RoutePermissionBoundary({ route, fallbackPath, children }: PropsWithChildren<{ route: AppRoute; fallbackPath: string }>) {
  const { authenticated, accessStatus } = useAdminAuthState();
  const location = useLocation();

  if (!authenticated) {
    const returnUrl = `${location.pathname}${location.search}`;
    return <Navigate to={`/login?returnUrl=${encodeURIComponent(returnUrl)}`} replace />;
  }
  if (accessStatus !== 'ready') {
    return <div className="route-permission-loading"><Spin tip="正在核验访问权限…" /></div>;
  }
  if (!canAccessRoute(route)) {
    return <GovernanceForbiddenPage fallbackPath={fallbackPath} />;
  }
  return children;
}
